import React from 'react';
import { Field, Form, Formik } from 'formik';
import { PageSection, FormBoolean } from 'adc-ui-components';

import StoreMethodContent from '../../../components/orders/StoreMethodContent';
import UpsMethodContent from '../../../components/orders/UpsMethodContent';
import GoBack from '../../../components/GoBack';
import { flagEnabled } from '../../../helpers/featureFlags';
import GenericError from '../../Errors/GenericError';

const StoreOrUps = ({
  selectedDevices,
  submitLoading,
  handleChooseReturnMethod,
  submitError,
}) => {
  const title = `How would you like to return your device${(selectedDevices.length > 1) ? 's' : ''}?`;
  const recommendUps = flagEnabled('device-returns.recommendUps');


  if (submitError) {
    return <GenericError />;
  }
  return (
    <PageSection className="ui-grey">
      <h1 className="heading2">{title}</h1>
      <Formik
        initialValues={{ method: recommendUps ? 'ups' : 'xfinityStore' }}
        onSubmit={handleChooseReturnMethod}
      >
        {({
          values: {
            method,
          },
        }) => {
          const xfinityStore = (
            <div className={`card card--form-control card--action-right-at-768 ${(method !== 'xfinityStore') ? 'card--inactive' : ''}`}>
              <div className="card__content">
                <FormBoolean className="form-control--boolean-mobile-top" label="Return at an Xfinity Store" labelClass="heading3" inputId="xfinityStore">
                  <Field component="input" id="xfinityStore" type="radio" name="method" value="xfinityStore" required />
                </FormBoolean>
              </div>
              {!recommendUps && (
                <div className="card__action">
                  <p className="badge badge--info">RECOMMENDED</p>
                </div>
              )}
            </div>
          );
          const ups = (
            <div className={`card card--form-control card--action-right-at-768 ${(method !== 'ups') ? 'card--inactive' : ''}`}>
              <div className="card__content">
                <FormBoolean className="form-control--boolean-mobile-top" label="UPS Prepaid Shipping" labelClass="heading3" inputId="ups">
                  <Field component="input" id="ups" type="radio" name="method" value="ups" required />
                </FormBoolean>
              </div>
              {recommendUps && (
                <div className="card__action">
                  <p className="badge badge--info">RECOMMENDED</p>
                </div>
              )}
            </div>
          );
          return (
            <Form>
              <div className="tabs-group">
                {recommendUps ? [ups, xfinityStore] : [xfinityStore, ups]}
              </div>

              {method === 'ups' && <UpsMethodContent />}
              {method === 'xfinityStore' && <StoreMethodContent />}

              <div className="action action--right">
                <div className="action__item">
                  <button type="submit" className={`button button--primary ${submitLoading && 'is-loading'}`} disabled={submitLoading}>Confirm</button>
                </div>
                <div className="action__item">
                  <GoBack>Back</GoBack>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </PageSection>
  );
};

export default StoreOrUps;
